import { AppGameLocationType } from '@core-http';
import { LocationTypeModel } from '../interfaces';

export const locationTypeMapper: Record<AppGameLocationType, LocationTypeModel> = {
  [AppGameLocationType.OPEN_FIELD]: {
    name: 'Orlik',
    bgColor: '#EFEBFE',
    textColor: '#5A31F4'
  },
  [AppGameLocationType.INDOOR]: {
    name: 'Hala',
    bgColor: '#e7e5ed',
    textColor: '#342375'
  },
  [AppGameLocationType.DOME]: {
    name: 'Balon ',
    bgColor: '#e4e3e8',
    textColor: '#13083B'
  },
  [AppGameLocationType.FIELD_FULL]: {
    name: 'Boisko ',
    bgColor: '#e4e3e8',
    textColor: '#13083B'
  }
};
